import { EmptyNlpScreen } from './EmptyNlpScreen'

export default EmptyNlpScreen
